import { render, staticRenderFns } from "./OverviewCourse.vue?vue&type=template&id=133fbd2c&scoped=true&"
import script from "./OverviewCourse.vue?vue&type=script&lang=js&"
export * from "./OverviewCourse.vue?vue&type=script&lang=js&"
import style0 from "./OverviewCourse.vue?vue&type=style&index=0&id=133fbd2c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133fbd2c",
  null
  
)

export default component.exports